<script lang="ts">
    
    import type { ImageContentDto } from "../../global";

    export let content: ImageContentDto;

</script>

<img src={content.image} alt="">

<style lang="scss">

    img {
        max-width: 100%;
    }

</style>
